import React from "react";
import { FrontColors } from "../../../../models/FrontColors";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { FrontSpacing } from "../../../../models/FrontSpacing";
import { TProbateLeadForm } from "../../../../../../domain/codecs/form/ProbateLeadForm";
import { onChangeForm } from "../../../../../../shared/src/codecs/types/form";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import FrontParagraphXXSmall from "../../../Front/Simple/FrontParagraphXXSmall/FrontParagraphXXSmall";
import { WeightMedium } from "../../../WeightMedium/WeightMedium";
import { TextColor } from "../../../BuildingBlocks/TextColor";
import { TextAlign } from "../../../BuildingBlocks/TextAlign";
import { FPInput } from "../FPInput/FPInput";
import { FPInputButton } from "../FPInputButton/FPInputButton";

export const FPMarketingHelplineCTAInput = (props: React.PropsWithChildren<{
    coloursInverted?: boolean;
    form: TProbateLeadForm;
    isSubmitting: boolean;
    disclaimer?: string;
    autoFocus?: boolean;
    alignDisclaimer?: "left" | "center" | "right";
    onChange: (form: TProbateLeadForm) => void;
    onSubmit: () => void;
}>): JSX.Element => {
    const coloursInverted = props.coloursInverted || false;

    const disclaimerColor = 
        coloursInverted
            ? FrontColors.NEUTRAL_18
            : FrontColors.NEUTRAL_0;

    const onChangePhone =
        props.isSubmitting
            ? () => undefined
            : onChangeForm(props.form, props.onChange)("phone");

    const onSubmit = () =>
        props.isSubmitting
            ? undefined
            : props.onSubmit();

    return <SpacingColumn spacing={FrontSpacing.SMALL_2}>
        <SpacingRow
            justifyContent="start"
            alignItems="center"
            childSize="1fr min-content"
        >
            {/* INPUT */}
            <FPInput
                flatEdge={true}
                coloursInverted={coloursInverted}
                value={props.form.edited.phone}
                placeholder="Enter your number here"
                autoFocus={props.autoFocus}
                onChange={onChangePhone}
                onEnter={onSubmit}
            />

            {/* CONTROL */}
            <FPInputButton
                coloursInverted={coloursInverted}
                iconName="chevron-right"
                onClick={onSubmit}
            />
        </SpacingRow>

        {/* DISCLAIMER */}
        {props.disclaimer &&
            <FrontParagraphXXSmall>
                <SpacingRow justifyContent="end">
                    <TextAlign position={props.alignDisclaimer || "right"}>
                        <TextColor color={disclaimerColor}>
                            <WeightMedium>
                                {props.disclaimer}
                            </WeightMedium>
                        </TextColor>
                    </TextAlign>
                </SpacingRow>
            </FrontParagraphXXSmall>
        }
    </SpacingColumn>;
};
